import React, { useState } from "react";
import { Button } from "react-bootstrap";
import CreateDispatchModal from "./CreateDispatchModal";
import DispatchList from "./DispatchList";
// import DeliveryTracking from "./DeliveryTracking";
import { useHasPermission, PERMISSIONS } from '../../utils/permissions';


export default function SODispatchTab({ orderId, orderData, items, onRefresh }) {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  // const canViewDispatch = useHasPermission(PERMISSIONS.DISPATCH_VIEW);
    const canAddDispatch = useHasPermission(PERMISSIONS.DISPATCH_CREATE);
    const canEditDispatch = useHasPermission(PERMISSIONS.DISPATCH_EDIT);

  const handleDispatchCreated = () => {
    setShowCreateModal(false);
    setRefreshKey(prev => prev + 1);
    if (onRefresh) onRefresh();
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Dispatch & Delivery Management</h5>
        {canAddDispatch && (
        <Button 
          variant="primary" 
          onClick={() => setShowCreateModal(true)}
        >
          + Create Dispatch Note
        </Button>
        )}
      </div>

      {/* Dispatch List */}
      <DispatchList
        salesOrderId={orderId}
        onRefresh={onRefresh}
        canEditDispatch={canEditDispatch}
        refreshKey={refreshKey}
      />

      <hr className="my-4" />

      {/* <DeliveryTracking salesOrderId={orderId} onRefresh={onRefresh} canEditDispatch={canEditDispatch} /> */}

      {canAddDispatch && (
      <CreateDispatchModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        salesOrderId={orderId}
        orderItems={items}
        onDispatchCreated={handleDispatchCreated}
      />
      )}
    </div>
  );
}
